import React from "react";
import { NavLink, useLocation } from "react-router-dom";

const CustomNavLink = ({ to, exact, activeClassName, children, ...props }) => {
  const location = useLocation();
  const paths = Array.isArray(to) ? to : [to];

  const isActive = paths.some((path) =>
    exact ? location.pathname === path : location.pathname.startsWith(path)
  );

  return (
    <NavLink
      to={paths[0]}
      className={isActive ? activeClassName : ""}
      {...props}
    >
      {children}
    </NavLink>
  );
};

export default CustomNavLink;
